import { IconButton } from "@material-ui/core"
import dynamic from "next/dynamic"
import { useEffect, useMemo, useRef, useState } from "react"
import VideoPlayIcon from "reusable/icons/VideoPlayIcon"
import VideoStopIcon from "reusable/icons/VideoStopIcon"
import styled from "styled-components"

const VideoPlayer = dynamic(() => import("common/VideoPlayer"), {
  loading: () => <p>...</p>,
})

const isUrlIsVideo = (url: string) => {
  const videoExtensions = ["mp4", "webm", "ogg"]
  const urlExtension = url.split(".").pop()
  return videoExtensions.includes(urlExtension)
}

const StyledVideoWrapper = styled.div<{ $height: string }>`
  height: ${(p) => p.$height};
  width: 100%;
  position: relative;
`

const StyledIconButton = styled(IconButton)`
  position: absolute;
  bottom: 0;
  padding: 0;
  right: 0;
  width: 80px;
  margin-bottom: 20px;
  margin-right: 5px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 40px;
    margin-right: 40px;
  }
`

type VideoModalProps = {
  src: string
  imgDesktop: string
  imgMobile: string
  alt: string
  height: string
}

const VideoModal = ({
  src,
  imgDesktop,
  imgMobile,
  alt,
  height,
}: VideoModalProps) => {
  const [playing, setPlaying] = useState(false)
  const videoRef = useRef(null)

  const observer = useMemo(() => {
    if (typeof window === "undefined") return null
    return new IntersectionObserver(([entry]) =>
      setPlaying(entry.isIntersecting)
    )
  }, [])

  useEffect(() => {
    observer?.observe(videoRef.current)

    return () => {
      observer?.disconnect()
    }
  }, [videoRef, observer])

  return (
    <StyledVideoWrapper $height={height} ref={videoRef}>
      <VideoPlayer
        url={src}
        light={false}
        label={"mazda"}
        playingState={playing}
        loop={true}
        imgAlt={alt}
        imgUrlDesktop={imgDesktop}
        imgUrlMobile={imgMobile}
      />
      {isUrlIsVideo(src) && (
        <>
          {playing ? (
            <StyledIconButton
              onClick={() => {
                setPlaying(false)
              }}
            >
              <VideoStopIcon />
            </StyledIconButton>
          ) : (
            <StyledIconButton onClick={() => setPlaying(true)}>
              <VideoPlayIcon />
            </StyledIconButton>
          )}
        </>
      )}
    </StyledVideoWrapper>
  )
}

export default VideoModal
